<template>
    <v-dialog persistent class="dialog" v-model="dialog" origin="top top">
        <v-card class="dialog-rebet__container">
            <template v-if="showTacTacWarning">
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red">{{ getTranslatedText('reprint dialog tac tac warning headline') }}</span>
                </v-card-title>
                <v-card-text class="dialog-rebet__description">
                    {{ getTranslatedText('reprint dialog tac tac not refundable') }}
                </v-card-text>
                <v-card-actions>
                    <ButtonCommon value="confirm" class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="false" nameFunction="on-reprint-tac-tac-confirm" />
                </v-card-actions>
            </template>
            <template v-else-if="showTicketCancelledConfirm">
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red">{{ getTranslatedText('reprint dialog ticket cancelled headline') }}</span>
                </v-card-title>
                <v-card-text class="dialog-rebet__description">
                    {{ getTranslatedText('reprint dialog ticket cancelled body') }}
                </v-card-text>
                <v-card-actions>
                    <ButtonCommon value="confirm" class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="false" nameFunction="on-reprint-cancelled-confirm" />
                </v-card-actions>
            </template>
            <template v-else>
                <v-card-title class="text-h8 dialog-rebet__title">
                    <span class="dialog-rebet__title__red dialog-rebet__title__block">{{ getTranslatedText('attention') }}</span>
                    <span v-if="reprintCount < reprintCountToShowCancel">{{ getTranslatedText("your transaction has been confirmed") }}</span>
                    <span v-if="reprintCount >= reprintCountToShowCancel">{{ getTranslatedText("your ticket has been reprinted") }}</span>
                </v-card-title>

                <v-card-text v-if="reprintCount < reprintCountToShowCancel" class="dialog-rebet__description">{{ getTranslatedText("reprint dialog instruction reprint phase") }}</v-card-text>
                <v-card-text v-if="reprintCount >= reprintCountToShowCancel && !isTacTac" class="dialog-rebet__description">{{ getTranslatedText("reprint dialog instruction cancel phase") }}</v-card-text>
                <v-card-text v-if="reprintCount >= reprintCountToShowCancel && isTacTac" class="dialog-rebet__description">{{ getTranslatedText("reprint dialog tac tac not refundable") }}</v-card-text>
                <v-card-text v-if="dialog && autoCancelRemainingSeconds > 0" class="dialog-rebet__description dialog-rebet__countdown">{{ getTranslatedText("reprint dialog countdown seconds", { seconds: String(autoCancelRemainingSeconds) }) }}</v-card-text>

                <v-card-actions>
                    <ButtonCommon v-if="$showCancelationInPos && reprintCount >= reprintCountToShowCancel && !isTacTac && !isAutoCancelling" value="non - cancel"
                        class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="isUpdating || isDevicePrinting" name-function="on-print-cancel" />

                    <ButtonCommon v-if="reprintCount < reprintCountToShowCancel && !isReprintDisabledByCountdown && !isAutoCancelling" value="non - reprint"
                        class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="isUpdating || isDevicePrinting" name-function="on-print-reprint" />
                        
                    <ButtonCommon v-if="reprintCount >= reprintCountToShowCancel && isTacTac && !isAutoCancelling" value="failed print - close"
                        class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="false" nameFunction="on-print-close" />
                        
                    <ButtonCommon v-if="!isAutoCancelling" value="Ticket is printed" class-name="dialog__box-button__item uppercase" :isNoHover="true"
                        :isLoading="isUpdating || isDevicePrinting" nameFunction="on-print-ok" />
                </v-card-actions>
            </template>
        </v-card>
    </v-dialog>
</template>

<script>
import languageMixins from "@/mixins/language/language-mixins";
import printMinxin from '@/mixins/print/print-mixin'
import EventBus from "@/utils/EventBus";
import ButtonCommon from "@/components/common/button/index.vue";
import BetslipsService from '@/services/betslip.service'
import { isArrayEmpty } from '@/utils/utils'
import { INSTANT_SLUG_GAME } from '@/constants/lotto'
import Vue from 'vue'

export default {
    mixins: [languageMixins, printMinxin],
    components: { ButtonCommon },
    data() {
        let data =
        {
            dialog: false,
            reference: "",
            ticketType: "",
            isUpdating: false,
            isDevicePrinting: true,
            printStatusMessage: '',
            paramPrint: null,
            userInfo: null,
            reprintCount: 0,
            shouldIncreasePrintedCount: false,
            reprintCountToShowCancel: this.$store.state.reprintCountToShowCancel ?? 3,
            showCancelationInPos: this.$store.state.showCancelationInPos ?? false,
            milisecondsToForceFinishPrinting: 3000,
            forSport: false,
            forLotto: false,
            autoCancelRemainingSeconds: 0,
            autoCancelIntervalId: null,
            showTicketCancelledConfirm: false,
            showTacTacWarning: false,
            isAutoCancelling: false,
        };
        return data;
    },
    mounted() {
        document.addEventListener('message', this.handlePrintMessageFromApk)
    },
    created() {
        EventBus.$on("on-show-reprint", (param) => {
            this.showTicketCancelledConfirm = false
            this.showTacTacWarning = false
            this.isAutoCancelling = false
            this.isDevicePrinting = true
            this.shouldIncreasePrintedCount = false
            this.reprintCount = 0
            Vue.prototype.$isReprintDialogShowing = true
            this.reference = param.reference;
            this.betslipId = param.betslipId;
            this.ticketType = param.ticketType;
            this.paramPrint = param.paramPrint;
            this.userInfo = param.userInfo;
            this.dialog = true;
            this.forSport = param.forSport;
            this.forLotto = param.forLotto;

            this.initTimeoutToForceFinishPrinting()
            this.startAutoCancelCountdown()
        });

        // actions
        EventBus.$on("on-print-ok", () => this.updatePrintingStatus());
        EventBus.$on("on-print-cancel", () => this.cancelBetslip());
        EventBus.$on("on-print-close", () => this.closeOnFailedPrinting());
        EventBus.$on("on-print-reprint", () => this.reprint());
        EventBus.$on("on-print-close", () => this.closeDialog());
        EventBus.$on("on-reprint-cancelled-confirm", () => this.goHomeAfterTicketCancelled());
        EventBus.$on("on-reprint-tac-tac-confirm", () => this.goHomeAfterTacTacWarning());
    },
    beforeDestroy() {
        this.clearAutoCancelCountdown()
        window.removeEventListener('message', this.handlePrintMessageFromApk)
    },
    destroyed() {
        EventBus.$off("on-show-reprint");

        EventBus.$off("on-print-ok");
        EventBus.$off("on-print-cancel");
        EventBus.$off("on-print-close");
        EventBus.$off("on-print-reprint");
        EventBus.$off("on-print-close");
        EventBus.$off("on-reprint-cancelled-confirm");
        EventBus.$off("on-reprint-tac-tac-confirm");
    },
    computed: {
        isTacTac() {
            try {
                return this.paramPrint?.transaction?.additionalInformation?.game_slug === INSTANT_SLUG_GAME
            } catch {
                return false
            }
        },
        isReprintDisabledByCountdown() {
            if (this.autoCancelRemainingSeconds <= 0) return false
            const printTimeoutSeconds = Math.ceil(this.milisecondsToForceFinishPrinting / 1000)
            return this.autoCancelRemainingSeconds <= printTimeoutSeconds
        },
    },
    methods: {
        resolveAutoCancelSeconds() {
            const fromStore = this.$store.state.autoCancelUnprintedCountdownSeconds
            if (fromStore != null && !Number.isNaN(fromStore)) {
                if (fromStore <= 0) return 0
                return fromStore
            }
            return 60
        },

        clearAutoCancelCountdown() {
            if (this.autoCancelIntervalId != null) {
                clearInterval(this.autoCancelIntervalId)
                this.autoCancelIntervalId = null
            }
            this.autoCancelRemainingSeconds = 0
        },

        startAutoCancelCountdown() {
            this.clearAutoCancelCountdown()
            const total = this.resolveAutoCancelSeconds()
            if (total <= 0) {
                return
            }
            this.autoCancelRemainingSeconds = total
            this.autoCancelIntervalId = setInterval(() => {
                this.autoCancelRemainingSeconds -= 1
                if (this.autoCancelRemainingSeconds <= 0) {
                    this.clearAutoCancelCountdown()
                    this.handleAutoCancelExpiry()
                }
            }, 1000)
        },

        handleAutoCancelExpiry() {
            if (!this.dialog || this.isUpdating || this.showTicketCancelledConfirm) {
                return
            }
            if (this.isTacTac) {
                this.showTacTacWarning = true
            }
            this.isAutoCancelling = true
            this.cancelBetslip().finally(() => {
                this.isAutoCancelling = false
            })
        },

        goHomeAfterTicketCancelled() {
            this.showTicketCancelledConfirm = false
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            this.$router.push('/')
        },

        goHomeAfterTacTacWarning() {
            this.showTacTacWarning = false
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
            this.$router.push('/')
        },

        closeDialog() {
             try {
                BetslipsService.cancelBetslip(this.betslipId, true)
             } catch (error) {
             }
            this.dialog = false
            Vue.prototype.$isReprintDialogShowing = false
        },

        handlePrintMessageFromApk(event) {
            const resp = JSON.parse(event.data)
            if (resp.command === 'print-status') {
                if (resp.code === 200) {
                    this.printStatusMessage = 'ok'
                } else {
                    // error from apk
                    this.printStatusMessage = 'not ok'
                }
                if (this.shouldIncreasePrintedCount === true) {
                    this.shouldIncreasePrintedCount = false
                    this.reprintCount++;
                }
                this.isDevicePrinting = false
            }
        },

        async updatePrintingStatus() {
            if (this.isUpdating === true) return;

            this.clearAutoCancelCountdown()

            // todo: update ui, not allow to call api when device is not finish printing (OPTIONAL)

            this.isUpdating = true;

            let res = await BetslipsService.updatePrintingStatus(this.ticketType, this.reference, this.reprintCount)

            // todo: need to check response?

            this.isUpdating = false;
            this.dialog = false;

            this.shouldIncreasePrintedCount = false
            this.reprintCount = 0
            this.isDevicePrinting = false

            Vue.prototype.$isReprintDialogShowing = false
        },

        async closeOnFailedPrinting() {
            if (this.isUpdating === true) return;

            // todo: update ui, not allow to call api when device is not finish printing (OPTIONAL)

            this.isUpdating = true;

            let res = await BetslipsService.updatePrintingStatus(this.ticketType, this.reference, this.reprintCount, false)

            // todo: need to check response?

            this.isUpdating = false;
            this.dialog = false;

            this.shouldIncreasePrintedCount = false
            this.reprintCount = 0
            this.isDevicePrinting = false

            Vue.prototype.$isReprintDialogShowing = false
        },

        async cancelBetslip() {
            if (this.isUpdating === true) return;
            this.clearAutoCancelCountdown()
            this.isUpdating = true;

            try {
                const resp = await BetslipsService.cancelBetslip(this.betslipId, true)
                if (this.isTacTac) return;
                if (resp.status === 200) {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : (message = resp.message)
                    const param = {
                        text: message ? message : 'cancel successfully',
                        type: 'success',
                    }
                    EventBus.$emit('show-notications', param)

                    this.showTicketCancelledConfirm = true
                } else {
                    let message = ''
                    !isArrayEmpty(resp.errors)
                        ? resp.errors.forEach((element) => {
                            message += element.message
                        })
                        : (message = resp.message)
                    const param = {
                        text: message,
                        type: 'error',
                        className: 'up-first'
                    }
                    EventBus.$emit('show-notications', param)
                }
            } catch (error) {
                console.log(error)
                const param = {
                    text: 'System error',
                    type: 'error',
                    className: 'up-first'
                }
                EventBus.$emit('show-notications', param)
            }

            this.isUpdating = false;
        },

        async reprint() {
            // this.reprintCount++;
            this.shouldIncreasePrintedCount = true;
            this.isDevicePrinting = true
            this.initTimeoutToForceFinishPrinting()

            if (this.forSport === true) {
                parent.postMessage({ command: 'print-sports', param: this.paramPrint }, '*')
                this.printSports(this.paramPrint, true)
            }

            if (this.forLotto === true) {
                parent.postMessage({ command: 'print-rebet-ticket', param: this.paramPrint }, '*')
                this.printLoto(this.paramPrint, true)
            }
        },

        initTimeoutToForceFinishPrinting() {
            setTimeout(() => {
                if (this.shouldIncreasePrintedCount === true) {
                    this.shouldIncreasePrintedCount = false
                    this.reprintCount++;
                    // only update if reprint
                    // BetslipsService.updatePrintingStatus(this.ticketType, this.reference, this.reprintCount)
                }
                this.isDevicePrinting = false
            }, this.milisecondsToForceFinishPrinting);
        }
    },
};
</script>

<style lang="scss">
@import "~ThemePath/scss/common/_dialog-rebet.scss";

.dialog-rebet__countdown {
    font-weight: 600;
    margin-top: 8px;
}

.dialog-rebet__title__block {
    display: block;
    width: 100%;
}
</style>
